/**
 * 模板市场入口模块
 * @author luoying, chenqunfeng
 * @since 18/06/07
 */

import '../global/global';

import './index.less';

import React from 'react';
import ReactDOM from 'react-dom';
import store from 'store';
import { Provider } from 'react-redux';

import Store from 'containers/store';
import { enableHMR } from 'utils/common';
import { initSSO } from 'components/sso/sso';

initSSO(data => {
  console.log(data);
});

ReactDOM.render(
  <Provider store={store}>
    <Store />
  </Provider>,
  document.getElementById('container')
);

enableHMR(module);
